document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("details").forEach((detail) => {
      console.log(detail);
        const summary = detail.querySelector("summary");
        if (!summary) return;
        const svgWrapper = summary.querySelector(".svg-wrapper");
        if (!svgWrapper) return;
        // Create the "X" SVG
        const xIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        xIcon.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        xIcon.setAttribute("viewBox", "0 0 192 192");
        xIcon.setAttribute("fill", "#000000");
        xIcon.classList.add("icon", "icon-x", "icon-toggle-minus");
        xIcon.innerHTML =
            '<path d="M30 96h132" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="12px"></path>';

        const originalIcon = svgWrapper.firstElementChild; // Store original arrow icon
 
        detail.addEventListener("toggle", function () {
            if (detail.open) {
              console.log("detail opened!");
                originalIcon.style.opacity = "0";
                originalIcon.style.transform = "rotate(180deg)";

                setTimeout(() => {
                    svgWrapper.innerHTML = "";
                    svgWrapper.appendChild(xIcon);
                    xIcon.style.opacity = "1";
                    xIcon.style.transform = "rotate(0deg)";
                }, 300);
            } else {
              console.log("detail closed!");
                xIcon.style.opacity = "0";
                xIcon.style.transform = "rotate(-180deg)";

                setTimeout(() => {
                    svgWrapper.innerHTML = "";
                    svgWrapper.appendChild(originalIcon);
                    originalIcon.style.opacity = "1";
                    originalIcon.style.transform = "rotate(0deg)";
                }, 300);
            }
        });
    });
});

  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

  document.querySelectorAll('.card__collection_badge').forEach(badge => {
    const span = badge.querySelector('span');
    if (span && span.textContent.trim() === "") {
        badge.style.display = "none";
    }
});





  // document.addEventListener('DOMContentLoaded', function () {
  //   // Get the product form (Add to Cart form)
  //   const productForm = document.querySelector('form[action^="/cart/add"]');
  //   if (!productForm) {
  //     console.warn('Product form not found.');
  //     return;
  //   }

  //   // Get the quantity input within this product form
  //   const quantityInput = document.querySelector('input.quantity__input[name="quantity"]');
  //   console.log(quantityInput);
  //   if (!quantityInput) {
  //     console.warn('Quantity input not found inside product form.');
  //     return;
  //   }

  //   // Radio buttons: one for 1 qty, one for 'set'
  //   const radios = document.querySelectorAll('input[name="qty_option"]');
  //   const dropdown = document.getElementById('saving-set-dropdown');

  //   function updateQuantity(value) {
  //     quantityInput.value = value;
  //     quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  //   }

  //   radios.forEach((radio) => {
  //     radio.addEventListener('change', function () {
  //       if (this.value === 'set') {
  //         // dropdown?.classList.remove('hidden');
  //         updateQuantity(dropdown.value);
  //       } else {
  //         // dropdown?.classList.add('hidden');
  //         updateQuantity(this.value);
  //       }
  //     });
  //   });

  //   dropdown?.addEventListener('change', function () {
  //     updateQuantity(this.value);
  //   });
  // });

  // document.addEventListener('DOMContentLoaded', function () {
  //   const productForm = document.querySelector('form[action^="/cart/add"]');
  //   if (!productForm) return;

  //   const quantityInput = document.querySelector('input.quantity__input[name="quantity"]');
  //   const radios = document.querySelectorAll('input[name="qty_option"]');
  //   const dropdown = document.getElementById('saving-set-dropdown');
  //   const discountedPriceEl = document.querySelector('.discounted-price');
  //   const originalPriceEl = document.querySelector('.original-price');

  //   // Replace with your product price in cents
  //   const productPrice = null;
  //   console.log("productprice + ")

  //   const discountMap = {
  //     2: 0.10,
  //     4: 0.15,
  //     6: 0.20
  //   };

  //   function formatMoney(cents) {
  //     return new Intl.NumberFormat('en-MY', {
  //       style: 'currency',
  //       currency: 'MYR',
  //       minimumFractionDigits: 0,
  //       maximumFractionDigits: 2
  //     }).format(cents / 100);
  //   }

  //   function updateQuantity(value) {
  //     quantityInput.value = value;
  //     quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
  //   }

  //   function updatePrices(quantity) {
      
  //     const original = productPrice * quantity;
  //     const discountRate = discountMap[quantity] || 0;
  //     const discounted = Math.round(original * (1 - discountRate));

  //     console.log("quantity" + quantity);
  //     console.log("original" + original);
  //     console.log("discounted" + discounted);

  //     if (discountedPriceEl && originalPriceEl) {
  //       discountedPriceEl.textContent = formatMoney(discounted);
  //       originalPriceEl.textContent = formatMoney(original);
  //     }
  //   }

  //   radios.forEach((radio) => {
  //     radio.addEventListener('change', function () {
  //       if (this.value === 'set') {
  //         const qty = parseInt(dropdown.value, 10);
  //         updateQuantity(qty);
  //         updatePrices(qty);
  //       } else {
  //         updateQuantity(1);
  //       }
  //     });
  //   });

  //   dropdown?.addEventListener('change', function () {
  //     const qty = parseInt(this.value, 10);
  //     updateQuantity(qty);
  //     updatePrices(qty);
  //   });

  //   // Initialize price display on load
  //   if (dropdown && document.querySelector('input[name="qty_option"][value="set"]').checked) {
  //     updatePrices(parseInt(dropdown.value, 10));
  //   }
  // });

  document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('product-form form');

  if (!productForm) return;

  productForm.addEventListener('submit', function (e) {
    e.preventDefault();

    const formData = new FormData(productForm);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(res => res.json())
      .then(data => {
        console.log('Added to cart:', data);

        // ✅ Reset custom quantity selector to "Buy 1"
        const buy1Radio = document.querySelector('input[name="qty_option"][value="1"]');
        const savingSetDropdown = document.getElementById('saving-set-dropdown');

        if (buy1Radio) buy1Radio.checked = true;

        // Optional: reset dropdown to default
        // savingSetDropdown.selectedIndex = 0;
      })
      .catch(err => {
        console.error('Add to cart failed:', err);
      });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.getElementById('saving-set-dropdown');
  const savingSetRadio = document.querySelector('input[name="qty_option"][value="set"]');

  if (dropdown && savingSetRadio) {
    dropdown.addEventListener('change', () => {
      savingSetRadio.checked = true;
    });
  }
});



Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
          get: function () {
          return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
          }
        });
        
        document.body.addEventListener("click", playVideoOnLowPower);
        document.body.addEventListener("touchstart", playVideoOnLowPower);
      
        function playVideoOnLowPower(){
          try{
          const videoElements = document.querySelectorAll("video");
          for (i = 0; i < videoElements.length; i++) {
            if (videoElements[i].playing) {
            } else {
            videoElements[i].play();
            }
          }
          }
          catch(err) {
          console.log(err);
          }
        }









